module.exports = __webpack_public_path__ + "img/0-02-0a-61723acd2b6c6ab77f1e1dfa30dcb4419660ea53044f0610907fb6e048120562_a647aec6.b16c9f5a.jpg";